// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-01-26T10:42:50+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191127
//    Project:        559
//    Environment:    5442 - master
//    MD5:            219aa0597efc9a05791e145e6952f782
//    Signature:      eyJpdiI6ImVTQVB5MmxmV3poQkxSVWJ3c1ZcL093PT0iLCJ2YWx1ZSI6InU0eFpwckRoNXZnelM4MWZuZzB0RXFDMW4rWFk1RWQrRlN0QjZFY1wvUlwvNTVcLzM2YitGaWJGZFpcL0xHUzBzT1MzZmtSdU9NcFlLS0NsVEpLY05kQjJcLzB1Qk5ISW5mRVZCNjFFS0ZUUmVDcVE1M2c4M1VCcUxEWGVZUkdoQm55TFVFQkFVVlJXV0pLQk50UG1sYkZrK0hJNUtnTjRYb3RnTzdPcFNaR0VLQzV4dFBURmxGNDFOTzNod29VTFhHM2ROV2cyNFlmTUJQUVQxellcL0pzaWxBWm1DekRVeTl2VFpcL252WUVKTEluNEdld3prMkVcL0h5QlN6VXo0Y09ndlZXSjUyYWx3VEVqSFZjZVVNRVhUYWtBS0gwdFg2dUkwYk5RR3o0VVY2R0hGa1pHWFJcL0orYlJDbDFTZlZPUG04cWgxQ05GQUYwQTNGS0dhUWJFV1ZwdVdGWHBrZTF5RGJpR0xOVGZER3hIbjltZG51YUJiRjJXTlRoclloN0FHeFdXOGNETHVYQ0dpd20xYXZ4a256NDVhY2c9PSIsIm1hYyI6IjM0MmFjMzBiZTllYTUyZmYyNTM5MDFlZWZlOGRkMDc4MWZhMDU3MjcyNzQ0NWEyZDliMTdiMjZmMmYwZTQ1MjAifQ==
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function quickAddToCart(form){
    $.ajax({
        type: "POST",
        url: '/cart/add',
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          // console.log("we made it!");
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
          
        }
      });
}

function faqFunctions() {
  $('.tab-title').click(function () {
    var index = $(this).data('index');
    $(this).addClass('active');
    $(this).siblings().removeClass('active');

    $('.tab-content[data-index="' + index + '"]').slideDown(300);
    $('.tab-content[data-index="' + index + '"]').siblings().slideUp(300);
  })
}

function toggleOption(form, variantName, value) {
  console.log('toggleOption');
  var variant = form.find('[name=id] option[data-title="' + variantName + '"]');

  if (variant.length > 0) {

    if (!variant.is(':disabled')) {
      value.removeClass('disabled');
    }
    else {
      value.addClass('disabled');
      console.log('.product-single__variants option[data-title="' + variantName + '"] should be disabled');
    }
  }
  else {
    value.addClass('disabled');
  }

}

function checkOptionTree(option) {
  console.log('checkOptionTree');
  var form = $('.ProductForm');


  var index = option.data('option-index');
  var toFind = '.ProductForm [name="id"] option';
  if (index == 2) {
    if (form.find('.ProductForm__Option[data-option-index="1"]').is("input")) {
      toFind = toFind + '[data-option-1="' + form.find('.ProductForm__Option[data-option-index="1"]').val() + '"]';
    }
    else {
      toFind = toFind + '[data-option-1="' + form.find('.ProductForm__Option[data-option-index="1"] [type="radio"]:checked').val() + '"]';
    }
  }
  console.log('index: ', index, '; toFind: ', toFind);

  if (option.is("input")) {
    console.log('option is input');

    var findString = toFind + '[data-option-' + index + '="' + option.val() + '"]:not([disabled])';

    option.removeClass('disabled');

    if ($(findString).length) {
      console.log(findString + 'tree is successful');

    }
    else {
      console.log(findString + 'tree is not successful');
      option.addClass('disabled');
    }
  }
  else {
    console.log('option is list');
    option.find('[type="radio"]').each(function () {

      var findString = toFind + '[data-option-' + index + '="' + $(this).val() + '"]:not([disabled])';

      console.log('findString:', findString);
      $(this).removeClass('disabled');

      if ($(findString).length > 0) {
        console.log(findString + ' tree is successful');

      }
      else {
        console.log(findString + ' tree is not successful');
        $(this).addClass('disabled');
      }

    })
  }

}

function updateAvailableOptions(form, elem) {
  // console.log('updateAvailableOptions');
  var form = $('.ProductForm');

  var select = form.find('[name="id"]');

  var optionsLength = form.find('.ProductForm__Option:not(.no-js)').length;

  var mainOpt = $('.ProductForm__Option[data-option-index="1"]');

  console.log('updateAvailableOptions is running fine; optionsLength: ' + optionsLength);

  if (optionsLength == 1) {
    if (mainOpt.is("input")) {
      var variantName = $(this).val();
      toggleOption(form, variantName, $(this));
    }
    else {
      mainOpt.find('[type="radio"]').each(function () {
        console.log('main option');
        var variantName = $(this).val();

        toggleOption(form, variantName, $(this));

      })
    }
  }
  else if (optionsLength == 2) {
    console.log('optionsLength is 2');

    checkOptionTree(mainOpt);
    if (mainOpt.is("input")) {
      var variantFirstName = mainOpt.val();
    }
    else {
      var variantFirstName = mainOpt.find('[type=radio]:checked').val();
    }

    var secOpt = $('.ProductForm__Option[data-option-index="2"]');


    secOpt.find('[type="radio"]').each(function () {
      console.log('new radio found: ', $(this).val());

      var variantSecondName = $(this).val();


      var variantName = variantFirstName + ' / ' + variantSecondName;
      toggleOption(form, variantName, $(this));

      console.log('variantName: ', variantName);


    })

  }
  else if (optionsLength == 3) {


    if (mainOpt.is("input")) {
      var variantFirstName = mainOpt.val();
    }
    else {
      var variantFirstName = mainOpt.find('[type=radio]:checked').val();
    }
    var secOpt = $('.ProductForm__Option[data-option-index="2"]');

    checkOptionTree(secOpt);
    checkOptionTree(mainOpt);

    if (secOpt.is("input")) {
      var variantSecondName = secOpt.val();
    }
    else {
      var variantSecondName = secOpt.find('[type=radio]:checked').val();
    }


    console.log('third level reached');
    var thirdOpt = $('.ProductForm__Option[data-option-index="3"]');

    thirdOpt.find('[type="radio"]').each(function () {
      console.log('new option found');
      var variantThirdName = $(this).val();

      var variantName = variantFirstName + ' / ' + variantSecondName + ' / ' + variantThirdName;
      toggleOption(form, variantName, $(this));
    })
  }
}

// sticky add to cart updates
function updateStickyATC() {
  const stickyBannerProductOption = document.querySelector('.product-sticky-bar__option');
  const stickyBannerProductPrice = document.querySelector('.product-sticky-bar__PriceList');
  const selectedVariantId = document.querySelector('.ProductForm [name="id"]').value;
  const productData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  const selectedVariant = productData.product.variants.find(v => v.id == selectedVariantId);
  const mainAddToCartButton = document.querySelector('.Product__InfoWrapper .ProductForm__AddToCart');
  if (mainAddToCartButton) {
    const span = mainAddToCartButton.querySelector('span');
    if (span) {
      span.replaceWith(...span.childNodes);
    }
  }

  if (selectedVariant) {
    // Update variant option name
    if (stickyBannerProductOption) {
      let variantName = selectedVariant.option1;
      if (selectedVariant.option2) variantName += ' / ' + selectedVariant.option2;
      if (selectedVariant.option3) variantName += ' / ' + selectedVariant.option3;

      stickyBannerProductOption.innerHTML = variantName;
    }

    // Update price
    const originalPrice = document.querySelector('.ProductMeta__PriceList');
    if (stickyBannerProductPrice && originalPrice) {
      stickyBannerProductPrice.innerHTML = originalPrice.innerHTML;
    }

    // Update Add to Cart button state & text
    const stickyAddToCartButton = document.querySelector('.product-sticky-bar__AddToCart');

    if (stickyAddToCartButton) {
      stickyAddToCartButton.textContent = mainAddToCartButton.innerHTML;
      if (selectedVariant.available) {
        stickyAddToCartButton.classList.remove('klaviyo-bis-trigger');
        if(stickyAddToCartButton.textContent == "Unavailable") {
          stickyAddToCartButton.classList.add('disabled');
          stickyAddToCartButton.setAttribute('disabled', 'true');
        } else {
          stickyAddToCartButton.classList.remove('disabled');
          stickyAddToCartButton.removeAttribute('disabled');
        }
      } else {
        stickyAddToCartButton.classList.add('klaviyo-bis-trigger');
      }
    }

    // Update Buy button state & text
    const stickyBuyButton = document.querySelector('.product-sticky-bar__BuyNow');
    if (stickyBuyButton) {
      if (selectedVariant.available) {
        stickyBuyButton.classList.remove('disabled');
        stickyBuyButton.removeAttribute('disabled');
        if(stickyAddToCartButton.textContent == "Unavailable") {
          stickyBuyButton.classList.add('disabled');
          stickyBuyButton.setAttribute('disabled', 'true');
        }
      }
      else {
        stickyBuyButton.classList.add('disabled');
        stickyBuyButton.setAttribute('disabled', 'true');
      }
    }
  }
}

$(document).on('click', '.product-sticky-bar__AddToCart', function ()  {
  $('.ProductForm__AddToCart').trigger('click');
});

$(document).on('click', '.product-sticky-bar__BuyNow', function ()  {
  $('.ProductForm__AddToCart').trigger('click');
   setTimeout(function () {
    window.location.href = '/checkout';
  }, 500);
});

function vertScrollFunctions() {

  function adjustArrows(wrapper) {
    var parent = wrapper.find('.scroll-area');
    var parentHeight = parent.outerHeight();
    var parentScrollHeight = parent[0].scrollHeight;
    var parentScrollTop = parent.scrollTop();

    if (parentScrollTop == 0) {
      wrapper.removeClass('mid-position').removeClass('end-position');
    }
    else if (parentScrollHeight <= parentHeight + parentScrollTop) {
      wrapper.removeClass('mid-position').addClass('end-position');
    }
    else {
      wrapper.addClass('mid-position').removeClass('end-position');
    }
  }

  $(document).on('click', '.scroll-arrow', function () {
    var arrow = $(this);
    var wrapper = arrow.parents('.vert-scroll-holder');
    var parent = wrapper.find('.scroll-area');
    var parentHeight = parent.outerHeight();
    var parentScrollHeight = parent[0].scrollHeight;
    var parentScrollTop = Math.round(parent.scrollTop());

    console.log('parentHeight: ', parentHeight, '; parentScrollHeight: ', parentScrollHeight, '; parentScrollTop: ', parentScrollTop);

    if (arrow.hasClass('scroll-up')) {
      parent.animate({ scrollTop: parentScrollTop - parentHeight }, 200);
    }
    else {
      parent.animate({ scrollTop: parentScrollTop + parentHeight }, 200);
    }

    adjustArrows(wrapper);
  })

  $('.scroll-area').on('scroll', function () {
    var wrapper = $(this).parents('.vert-scroll-holder');
    var parent = wrapper.find('.scroll-area');
    var parentHeight = parent.outerHeight();
    var parentScrollHeight = parent[0].scrollHeight;
    var parentScrollTop = Math.round(parent.scrollTop());

    console.log('parentHeight: ', parentHeight, '; parentScrollHeight: ', parentScrollHeight, '; parentScrollTop: ', parentScrollTop);

    adjustArrows(wrapper);
  })
}

function addPlayingClass() {
  $('.ImageHero__NativeVideoHolder').addClass('playing');
}

$(document).on('click', 'a', function (e) {
  if ($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0) {
    if ($(e.target).is('.instafeed-overlay') || location.hash.includes("-insta-feed")) {
      return;
    }
    e.preventDefault();


    var scrolltop = $($(this).attr('href')).offset().top - $('#shopify-section-header').outerHeight() - 20;


    $('html, body').animate({ scrollTop: scrolltop }, 300);
    return false;
  }
})

document.addEventListener('DOMContentLoaded', () => {
  if ($('.vert-scroll-holder').length > 0) {
    vertScrollFunctions();
  }

  $(document).on('change', '.ProductForm [type="radio"]', function () {
    updateAvailableOptions($('.ProductForm'), $(this));
    updateStickyATC();
  })

  updateAvailableOptions($('.ProductForm'), '');

  if ($('[data-section-type="faq"]').length > 0) {
    faqFunctions();
  }

  $('.ProductForm--dynamic').submit(function (e) {
    e.preventDefault();
    quickAddToCart($(this));

  })

  $('.Blog__TagList').change(function () {

    window.location.href = $(this).val();
  })

  if ($(window).width() < 876) {
    $('[data-section-type="native-background-video"]').click(function () {

      console.log('video should play now');
      $(this).find('video')[0].play();

      $(this).find('.ImageHero__NativeVideoHolder').addClass('playing');
    })

    $('[data-section-type="native-background-video"] video').on("play", function (e) {
      $(this).parents('[data-section-type="native-background-video"]').find('.ImageHero__NativeVideoHolder').addClass('playing');
    });
  }

  $(document).on('click', '.quick-add-holder', function (e) {
    e.preventDefault();
  });

  $(document).on('change', '.ProductItem select', function () {
    var parent = $(this).parents('.ProductItem');
    var productData = JSON.parse(parent.find('[data-product-json]').html());
    var newVariantId;
    productVariants = productData.product.variants;
    // console.log('productVariants: ', productVariants);

    for (var i = 0; i < productVariants.length; i++) {

      var optionValue1 = null;
      var optionValue2 = null;
      var optionValue3 = null;
      if (parent.find('[data-option-index="1"]').length > 0) {
        optionValue1 = parent.find('[data-option-index="1"]').val();
      }
      if (parent.find('[data-option-index="2"]').length > 0) {
        optionValue2 = parent.find('[data-option-index="2"]').val();
        console.log('optionValue2', optionValue2);
      }
      if (parent.find('[data-option-index="3"]').length > 0) {
        optionValue3 = parent.find('[data-option-index="3"]').val();
        console.log('optionValue3', optionValue3);
      }

      if (optionValue1 == productVariants[i].option1 && optionValue2 == productVariants[i].option2 && optionValue3 == productVariants[i].option3) {

        newVariantId = productVariants[i].id;
        parent.find('[name="id"]').val(productVariants[i].id);

        console.log(parent.find('[name="id"]').val());
      }
    }

    var selectedOption = parent.find('[name="id"] option[value="' + newVariantId + '"]');
    if (selectedOption.length == 0) {
      console.log('option not found: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else if (selectedOption.prop('disabled') == true) {
      console.log('option is disabled: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else {
      console.log('option available: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').removeClass('disabled').removeAttr('disabled');
    }

    updateStickyATC();
  })

  $(document).on('click', '.ProductItem .ProductForm__AddToCart', function () {
    var parent = $(this).parents('.ProductItem');
    quickAddToCart(parent.find('form'));

    parent.find('.select-js .button-options__option input').removeClass('selected');
    parent.find('.select-js .button-options__option input').prop('checked', false);
    if (parent.find('.ProductCardLookItem__AddToCart').hasClass('single')) {
      parent.find('.ProductCardLookItem__AddToCart').removeClass('disabled');
    } else {
      parent.find('.ProductCardLookItem__AddToCart').addClass('disabled')
    }
  })

  document.querySelectorAll('.toggle-button').forEach(button => {
    button.addEventListener('click', function () {
      const wrapper = this.closest('.collectionDescription');
      const shortText = wrapper.querySelector('.short-text');
      const fullText = wrapper.querySelector('.full-text');
      const isExpanded = fullText.classList.contains('expanded');

      if (isExpanded) {
        // Collapse full text
        fullText.classList.remove('expanded');
        shortText.style.display = 'inline';
      } else {
        // Expand full text
        fullText.classList.add('expanded');
        shortText.style.display = 'none';
      }
    });
  });

  // gift card add to cart

  $(document).on('click', '.addUpsellToCart', function () {
    data = {
      "id": $(this).data('id'),
      "quantity": 1,
      "properties": {
        "Gift wrap": "Yes"
      }
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        // console.log("we made it!");
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            })
          );
      }
    });
  })

  setTimeout(function () {
    $('.quick-add-trigger').click(function (event) {
      event.stopPropagation(); // Prevent the click from bubbling up
      const parent = $(this).closest('.ProductItem__Media'); // Get the parent container

      // Toggle the current holder and reset others
      if (parent.find('.quick-add-holder').hasClass('show')) {
        // If already shown, hide it
        parent.find('.quick-add-holder').removeClass('show');
        parent.find('.moreInfoTag').removeClass('hide');
        $('html').removeClass('quick-add-active');
      } else {
        // Hide all holders and show the clicked one
        $('.quick-add-holder').removeClass('show');
        $('.moreInfoTag').removeClass('hide');
        parent.find('.quick-add-holder').addClass('show');
        parent.find('.moreInfoTag').addClass('hide');
        $('html').addClass('quick-add-active');
      }

      parent.find('select option').prop('selected', function () {
        return this.defaultSelected;
      });

      parent.find('.select-js .button-options__option input').removeClass('selected');
      parent.find('.select-js .button-options__option input').prop('checked', false);

      if (parent.find('.ProductForm__AddToCart').hasClass('single')) {
        parent.find('.ProductForm__AddToCart').removeClass('disabled');
      } else {
        parent.find('.ProductForm__AddToCart').addClass('disabled')
      }

    });
  }, 1000);

  // close quick add
  $(document).on('click', '.quick-add-close', function (event) {
    event.stopPropagation(); // Prevent the click from bubbling up
    const parent = $(this).closest('.ProductItem__Media'); // Get the parent container
    parent.find('.quick-add-holder').removeClass('show');
    parent.find('.moreInfoTag').removeClass('hide');
    $('html').removeClass('quick-add-active');
  });

  // Close .quick-add-holder when clicking outside
  $(document).click(function (event) {
    if (!$(event.target).closest('.quick-add-holder, .quick-add-trigger').length) {
      $('.quick-add-holder').removeClass('show');
      $('.moreInfoTag').removeClass('hide');
      $('html').removeClass('quick-add-active');
    }
  });

  // Function to handle the toggling of elements based on screen size
  function toggleQuickAddHolders() {
    if ($(window).width() < 768) {
      if ($('.quick-add-holder-desktop').length) {
        $('.quick-add-holder-desktop').remove();
      }
    } else {
      if ($('.quick-add-holder-mobile').length) {
        $('.quick-add-holder-mobile').remove();
      }
    }
  }

  toggleQuickAddHolders();

  $(document).on('click', '.ProductItem .select-js .button-options__option', function () {
    var parent = $(this).parents('.ProductItem');
    var productData = JSON.parse(parent.find('[data-product-json]').html());
    var newVariantId;
    var productVariants = productData.product.variants;

    var selectedRadio = $(this).find('input[type="radio"]');
    selectedRadio.prop('checked', true);
    selectedRadio.addClass('selected');

    var selectedOptionWrap = $(this).parents('.button-options');
    selectedOptionWrap.find('.button-options__option').not(this).find('input[type="radio"]').prop('checked', false);
    selectedOptionWrap.find('.button-options__option').not(this).find('input[type="radio"]').removeClass('selected');

    // Collect option values dynamically based on available data-option-index attributes
    var selectedOptions = [];
    parent.find('[data-option-index]').each(function () {
      var optionIndex = $(this).data('option-index');
      var optionValue = $(this).find('input[type="radio"].selected').val() || $(this).val();
      selectedOptions[optionIndex - 1] = optionValue; // Store values in an array indexed from 0
    });

    // Match the variant based on selected options
    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];
      if (
        (selectedOptions[0] === undefined || selectedOptions[0] == variant.option1) &&
        (selectedOptions[1] === undefined || selectedOptions[1] == variant.option2) &&
        (selectedOptions[2] === undefined || selectedOptions[2] == variant.option3)
      ) {
        newVariantId = variant.id;
        parent.find('[name="id"]').val(variant.id);
        console.log(parent.find('[name="id"]').val());
        break;
      }
    }

    var selectedOption = parent.find('[name="id"] option[value="' + newVariantId + '"]');
    if (selectedOption.length == 0) {
      console.log('option not found: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else if (selectedOption.prop('disabled') == true) {
      console.log('option is disabled: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else {
      console.log('option available: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductForm__AddToCart').removeClass('disabled').removeAttr('disabled');
    }
  });


  document.querySelectorAll('[data-section-type="announcement-bar"]').forEach(function (parent) {
    let index = 1;
    const time = parent.getAttribute('data-time') || 5000; // Default time if `data-time` is not set

    setInterval(function () {
      index++;

      const nextContent = parent.querySelector(`.AnnouncementBar__Content[data-index="${index}"]`);
      if (!nextContent) {
        index = 1;
      }

      // Hide all announcements except the one with the current index
      parent.querySelectorAll('.AnnouncementBar__Content').forEach(function (content) {
        if (content.getAttribute('data-index') == index) {
          content.style.display = 'block'; // Show current announcement
        } else {
          content.style.display = 'none'; // Hide others
        }
      });
    }, time);
  });

  function scrollToPosition() {
    const offset = 164; // Height of your sticky header
    const hash = window.location.hash;

    if (hash.startsWith('#store')) {
      const targetEl = document.querySelector(hash);
      if (targetEl) {
        const elementTop = targetEl.getBoundingClientRect().top + window.scrollY;
        const scrollToPosition = elementTop - offset;

        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth'
        });
      }
    }
  }
  setTimeout(() => {
    scrollToPosition();
  },100);
  
  // productCartLookItem options selected
  $(document).on('click', '.productCardLookItem .button-options__option', function () {
    var parent = $(this).parents('.productCardLookItem');
    var productData = JSON.parse(parent.find('[data-product-json]').html());
    var newVariantId;
    var productVariants = productData.product.variants;

    var selectedRadio = $(this).find('input[type="radio"]');
    selectedRadio.prop('checked', true);
    selectedRadio.addClass('selected');

    var selectedOptionWrap = $(this).parents('.button-options');
    selectedOptionWrap.find('.button-options__option').not(this).find('input[type="radio"]').prop('checked', false);
    selectedOptionWrap.find('.button-options__option').not(this).find('input[type="radio"]').removeClass('selected');

    // Collect option values dynamically based on available data-option-index attributes
    var selectedOptions = [];
    parent.find('[data-option-index]').each(function () {
      var optionIndex = $(this).data('option-index');
      var optionValue = $(this).find('input[type="radio"].selected').val() || $(this).val();
      selectedOptions[optionIndex - 1] = optionValue; // Store values in an array indexed from 0
    });

    // Match the variant based on selected options
    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];
      if (
        (selectedOptions[0] === undefined || selectedOptions[0] == variant.option1) &&
        (selectedOptions[1] === undefined || selectedOptions[1] == variant.option2) &&
        (selectedOptions[2] === undefined || selectedOptions[2] == variant.option3)
      ) {
        newVariantId = variant.id;
        parent.find('[name="id"]').val(variant.id);
        console.log(parent.find('[name="id"]').val());
        break;
      }
    }

    var selectedOption = parent.find('[name="id"] option[value="' + newVariantId + '"]');
    if (selectedOption.length == 0) {
      // console.log('option not found: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductCardLookItem__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else if (selectedOption.prop('disabled') == true) {
      // console.log('option is disabled: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductCardLookItem__AddToCart').addClass('disabled').attr('disabled', true);
    }
    else {
      // console.log('option available: [name="id"] option[value="' + newVariantId + '"]');
      parent.find('.ProductCardLookItem__AddToCart').removeClass('disabled').removeAttr('disabled');
    }

    updateAddAllToCartForm();
    setTimeout(checkButtonState, 0);

  });

  $(document).on('click', '.productCardLookItem .ProductCardLookItem__AddToCart', function () {
    var parent = $(this).parents('.productCardLookItem');
    quickAddToCart(parent.find('form'));
  })

  // add all to cart button state
  function checkButtonState() {
    const lookProduct = document.querySelector('.lookProducts');
    if (lookProduct) {
      const lookProductButtons = $(lookProduct).find('.ProductCardLookItem__AddToCart');
      
      // Ensure we're checking for the presence of the "disabled" class, not just attribute
      const allEnabled = lookProductButtons.toArray().every(btn => {
        const $btn = $(btn);
        return !$btn.prop('disabled') && !$btn.hasClass('disabled');
      });
  
      const addAllButton = $(lookProduct).find('.productCardLookItem__AddAllToCart');
      const addAllText = addAllButton.find('span');
      if (allEnabled) {
        addAllButton.prop('disabled', false).removeClass('disabled');
        addAllText.innerHTML = "Add All to Cart";
      } else {
        addAllButton.prop('disabled', true).addClass('disabled');
        addAllText.innerHTML ="Select all sizes to add all";
      }
    }
  }
  
  // update all inputs to add to cart form
  function updateAddAllToCartForm() {
    const form = document.querySelector('.lookProducts__Form');
    if (!form) return;
  
    // Remove any previous variant inputs
    $(form).find('input[type="hidden"]').remove(); // Now removing 'items[][id]' instead of 'id[]'
  
    // For each product card, collect the selected variant ID
    $('.productCardLookItem').each(function () {
      const variantId = $(this).find('[name="id"]').val();
  
      if (variantId && !isNaN(parseInt(variantId))) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'items[][id]'; // Using the correct name structure for Shopify
        input.value = variantId;
        form.appendChild(input); // Append the new input to the form
      }
    });
  }
  
  
  // add all to cart fucntionality

  $(document).on('click', '.productCardLookItem__AddAllToCart', function (e) {
    var productForm = $(this).closest('.lookProducts__Form'); // Use closest instead of parents to get the right form element
    e.preventDefault(); 
    openSideCart(productForm);
  });
  
  function openSideCart(productForm) {
    openDrawer();
  
    // Start Ajax request to add the products to the cart
    var formData = productForm.serialize(); // Serialize the form using jQuery's .serialize() method
  
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // Ensure the correct content type for form data
        'X-Requested-With': 'XMLHttpRequest' // Shopify's requirement for Ajax requests
      }
    }).then(function (response) {
      if (response.ok) {
        // Trigger the sidecart to open after successfully adding items
        openDrawer();
  
        // Dispatch a custom event for the product added
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
          }
        }));
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
  
          // Optionally show the error message somewhere (e.g., next to the Add to Cart button)
          document.querySelector('.productCardLookItem__AddAllToCart').after(errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove(); // Remove error after 2.5 seconds
          }, 2500);
        });
      }
    });
  }
  
  function openDrawer() {
    // Correct method to add class using vanilla JavaScript
    document.querySelector('[data-section-type="cart"]').classList.add('open'); // Adds the 'open' class to the cart drawer
  }

})


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const productOptions = $('.productCardLookItem .button-options__option');  
    productOptions.find('input[type="radio"]').removeClass('selected');
    productOptions.find('input[type="radio"]').prop('checked', false);
  }, 1);
});


// slide video play on click/touch in mobile
document.addEventListener('DOMContentLoaded', () => {
  const sliderVideo = $('.Slideshow__VideoContainer'); 
    $(document).on('click', sliderVideo, function () {
       $(this).find('video')[0].play();
    })
});

